import React, { useEffect, useState } from 'react'
import ProviderCardComponent from './provider-card.component';
import { setBackHandler, setHeaderTitle, } from "../../helpers/header.helper";
import { appNote, DialogHeaders, pageTitles } from '../shared/constants';
import { Link, useNavigate } from 'react-router-dom';
import { AppRoutes } from '../routes/route.path';
import { ProviderService } from '../../services/channels/ChannelProviderService';
import { ChannelAccountModel, ChannelProviderStatus, ChannelType } from '../../models/channels/channels.model';
import { BackMobileIcon, FbInstaIcon, LiveChatIcon, GoogleBusinessIcon, WhatsAppIcon } from '../../icon';
import { useSelector } from "react-redux";
import * as selector from '../../selectors/selectors';
import { Grid } from '@mui/material';
import DashBoardHeroIcon from '../../icons/dashboard-hero-icon.svg'
import { ChannelPlanModel, ChannelPlanStatus } from '../../models/users.model';
import UpgradePlanInfoComponent from '../channel-plans/upgrade-plan-info.component';

interface IProps {
    CloseAddChanel: () => void;
}

interface Provider {
    Type: ChannelType;
    Name: string;
    Status: ChannelProviderStatus
}

const ProviderViewComponent = (props: IProps) => {

    const PlanDetails: ChannelPlanModel = useSelector(selector.PlanDetails);
    const Channels: ChannelAccountModel[] = useSelector(selector.Channels);

    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
    const ActiveChannelsTypes: number[] = useSelector(selector.ActiveChannelsTypes)

    const navigate = useNavigate();

    const [providers, setProviders] = useState<Provider[]>([]);

    const [showUpgradePlan, setShowUpgradePlan] = useState<boolean>(false)


    useEffect(() => {
        setHeaderTitle(pageTitles.ADD_NEW_CHANNEL);
        setBackHandler(() => navigate(-1));
        ProviderService.getChannels().then((res) => {
            if (res.status === 200) {
                setProviders(res.data.map(x => ({
                    Type: x.id,
                    Name: x.name,
                    Status: x.status
                } as Provider)))
            }
        }).catch(err => { })
    }, []);

    const openFacebookChannel = () => {

    };

    const closeFacebookChannel = () => {
        setHeaderTitle(DialogHeaders.ADD_NEW_CHANNEL);
        setBackHandler(() => navigate(-1));
    };

    const openInstaChannel = () => {
        setHeaderTitle(DialogHeaders.INSTAGRAM_MESSANGER);
        setBackHandler(closeInstaChannel)
    };

    const closeInstaChannel = () => {
        setHeaderTitle(DialogHeaders.ADD_NEW_CHANNEL);
        setBackHandler(() => navigate(-1));
    };

    const openLiveChatChannel = () => {

        let Widgets = PlanDetails.FeatureKeys?.find(x => x.includes("widget"))?.split("-")[0] || 0
        let planSupportMoreWidgets = (Number(Widgets) * PlanDetails.Quantity > Channels.filter(x => x.ChannelType === ChannelType.LIVE_CHAT).length) || PlanDetails.FeatureKeys?.includes("unlimited-websites")

        if (PlanDetails.Status === ChannelPlanStatus.INACTIVE) {
            setShowUpgradePlan(true)
        }
        else if (planSupportMoreWidgets) {
            setHeaderTitle(DialogHeaders.LIVE_CHAT);
            navigate(AppRoutes.ADD_CHANNELS_LIVE_CHAT)
            setBackHandler(closeLiveChatChannel)
        }
        else {
            setShowUpgradePlan(true)
        }
    };

    const closeLiveChatChannel = () => {
        setHeaderTitle(DialogHeaders.ADD_NEW_CHANNEL);
        setBackHandler(() => navigate(-1))
    };

    const addGoogleBusinessMessages = () => {
        window.open("https://forms.gle/BMqBUoDbdhkPXzyF6", "_blank")
    };



    const getProviderCard = (provider: Provider) => {
        switch (provider.Type) {
            case ChannelType.FACEBOOK:
                return <Grid className='d-flex justify-center align-center' item xs={10} md={5} lg={4} xl={3} sm={10} >
                    <Link to={ActiveChannelsTypes.includes(provider.Type) ? AppRoutes.ADD_CHANNELS_BY_TYPE.replace(":Type", "1") : ""}>
                        <ProviderCardComponent Icon={<FbInstaIcon />} Label={appNote.FACEBOOK_AND_INSTAGRAM} Text={appNote.FACEBOOK_AND_INSTAGRAM_MESSAGES_FROM_FALKON} ActiveChannel={ActiveChannelsTypes.includes(provider.Type)} />
                    </Link>
                </Grid>
            case ChannelType.INSTAGRAM:
                return null
            case ChannelType.LIVE_CHAT:
                return <Grid className='d-flex justify-center align-center' item xs={10} md={5} lg={4} xl={4} sm={10} >
                    <ProviderCardComponent openNewChannel={openLiveChatChannel} Icon={<LiveChatIcon className='w-5 h-5' />} Label={appNote.LIVE_CHAT} Text={appNote.LIVE_CHAT_MESSAGES_FROM_FALKON} ActiveChannel={ActiveChannelsTypes.includes(provider.Type)} />
                </Grid>
            // case ChannelType.GOOGLE_BUSINESS:
            //     return <Grid className='' item xs={10} md={5} lg={4} xl={3} sm={10} >
            //         <div onClick={addGoogleBusinessMessages}>
            //             <ProviderCardComponent Icon={<GoogleBusinessIcon />} Label={appNote.GOOGLE_BUSINESS} Text={appNote.GOOGLE_BUSINESS_MESSAGES_FROM_FALKON} ActiveChannel={ActiveChannelsTypes.includes(provider.Type)}/>
            //         </div>
            //     </Grid>
            // case ChannelType.MESSENGER:
            //     return <Grid className='' item xs={6} md={4} xl={4} sm={4} >
            //         <Link to={AppRoutes.ADD_CHANNELS_INSTAGRAM}>
            //             <ProviderCardComponent openNewChannel={openInstaChannel} Icon={InstaIcon} Label={appNote.INSTAGRAM} Text={appNote.INSTAGRAM_MESSAGES_FROM_FALKON} ActiveChannel={ActiveChannelsTypes.includes(provider.Type)}/>
            //         </Link>
            //     </Grid>
            case ChannelType.WHATSAPP:
                return <Grid className='d-flex justify-center align-center' item xs={10} md={5} lg={4} xl={3} sm={10} >
                    <Link to={ActiveChannelsTypes.includes(provider.Type) ? AppRoutes.ADD_CHANNELS_BY_TYPE.replace(":Type", "3") : ""}>
                        <ProviderCardComponent openNewChannel={openInstaChannel} Icon={<WhatsAppIcon className='w-5 h-5' />} Label={"Whatsapp"} Text={appNote.WHATSAPP_MESSAGES_FROM_FALKON} ActiveChannel={ActiveChannelsTypes.includes(provider.Type)} />
                    </Link>
                </Grid>
            default:
                return null
        }
    };


    return (
        <>
            {IsMobileDevice ?
                <div className="paper-background o-x-hidden w-fill">
                    <Grid item xs={12}>
                        <div className='box-shadow-display-background-shadow d-flex p-2'>
                            {IsMobileDevice && <span><BackMobileIcon className={"c-pointer pr-2"} onClick={() => navigate(-1)} /></span>}
                            <span className={`h1 my-auto color-add-details-title mr-auto`}>{DialogHeaders.ADD_NEW_CHANNEL}</span>
                        </div>
                    </Grid>
                    <Grid container className='' justifyContent="center">
                        {providers.filter(x => ActiveChannelsTypes.includes(x.Type)).map(x => getProviderCard(x))}
                    </Grid>
                </div> :
                <div className='w-p-100 h-p-100 bg-color-grid pt-6 o-y-scroll'>
                    <div className='w-p-90 mx-auto mb-4 bg-color-add-channel-header h-p-22 br-2 d-flex justify-around'>
                        <div className='h1-semibold color-secondary h-p-60 my-auto w-p-50'>
                            <div className='w-p-100 d-flex align-end w-space'>
                                Stay Connected
                            </div>
                            <div className='w-p-100 d-flex align-start'>
                                Choose your preferred channel!!!
                            </div>
                        </div>
                        <div className='h-p-100'>
                            <img src={DashBoardHeroIcon} className='h-p-80 my-auto' />
                        </div>
                    </div>
                    <Grid container className='w-p-90 d-flex justify-around mx-auto'>
                        {providers.filter(x => ActiveChannelsTypes.includes(x.Type)).map(x => getProviderCard(x))}
                    </Grid>
                </div>
            }

            {
                showUpgradePlan && <UpgradePlanInfoComponent show={showUpgradePlan} close={() => { setShowUpgradePlan(false) }} AcessingFeatures={[{ featureName: `${PlanDetails.Status === ChannelPlanStatus.INACTIVE ? "Subscription Required" : "Add More Widgets"}`, Desc: `${PlanDetails.Status === ChannelPlanStatus.INACTIVE ? "Subscribe to a plan to unlock all features" : "To add live chat widgets to more websites please upgrade your plan"}` }]} />
            }

        </>
    )

}

export default ProviderViewComponent